import React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import AmChart from '../AmchartsWrapper'
import CalendarArrows from './CalendarArrows'
import { AmChartTypes, configMap } from './constants'
import { InlineLoading } from '../../Loading'
import ArrowsButtons from '../components/ArrowsButtons'
import Actions from '../components/Actions'
import { isEmpty } from 'lodash'
import { useTheme, useThemeVariable } from '../../Theme'

const AmChartsBuilder = ({
  type,
  data,
  size,
  color,
  config,
  calendar,
  valueDate,
  customDates,
  onChartReady,
  onDateChange,
  labelCalendar,
  minDate,
  maxDate,
  legendLabels,
  language,
  theme,
  chartTitle,
  hideChartTitle,
  isError = false,
  isLoading = false,
  isDataEmpty = false,
  chartBackground = false,
  noDataLabel = 'NO_DATA',
  arrowsConfig,
  actions
}) => {
  const currentTheme = useTheme()
  const chartTheme = theme || currentTheme.theme

  const defaultLabelColor = useThemeVariable('text01')
  const chartColor = { labelColor: defaultLabelColor, ...color }

  const getConfig = configMap[type]
  if (!getConfig) {
    return null
  }

  return (
    <div className='amcharts-container'>
      {(chartTitle || !isEmpty(arrowsConfig)) && (
        <div
          className={cn('amcharts-header', { 'bg-header': chartBackground })}
        >
          <div>
            {chartTitle && (
              <h4
                className={cn('amcharts-title', {
                  'bg-title': chartBackground,
                  'bg-hide-title': hideChartTitle
                })}
              >
                {chartTitle}
              </h4>
            )}
          </div>
          <div className='amchart-btns-wrapper'>
            {!isEmpty(actions) && <Actions actions={actions} />}
            {!isEmpty(arrowsConfig) && (
              <div
                className={cn('amcharts-arrows', {
                  'bg-arrows': chartBackground
                })}
              >
                <ArrowsButtons arrowsConfig={arrowsConfig} />
              </div>
            )}
          </div>
        </div>
      )}
      {calendar && (
        <CalendarArrows
          chartBackground={chartBackground}
          valueDate={valueDate}
          onDateChange={onDateChange}
          labelCalendar={labelCalendar}
          customDates={customDates}
          minDate={minDate}
          maxDate={maxDate}
        />
      )}
      <div
        className={cn('chart', size, {
          'status-box': isLoading || isError || isDataEmpty,
          'bg-chart': chartBackground
        })}
      >
        {isLoading ? (
          <InlineLoading />
        ) : isError || isDataEmpty ? (
          <div>{noDataLabel}</div>
        ) : (
          <AmChart
            theme={chartTheme}
            language={language}
            onChartReady={onChartReady}
            config={getConfig({
              config,
              data,
              color: chartColor,
              legendLabels
            })}
          />
        )}
      </div>
    </div>
  )
}

AmChartsBuilder.propTypes = {
  type: PropTypes.oneOf(Object.keys(AmChartTypes)).isRequired,
  props: PropTypes.any
}

export default AmChartsBuilder
